import { cx, toMoney } from "shared/utils";
import { CriteriaBadgeIcon } from "shared/components/CriteriaBadgeIcon";
import { useMemo } from "react";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { PermittedContent } from "../../../PermittedContent";
import { VerifiedBadge } from "shared/components/VerifiedBadge";

export const SingleGroupStat = ({
  label,
  value,
  criteriaImportance,
  hasCriteria,
  criteriaSuccess,
  valueType = "money",
  noBorders = false,
  isPermitted,
  isVerified,
  isSelfAttested,
  onEditEmp,
  empValue
}: {
  label: string;
  value?: number | null;
  criteriaImportance?: number | null;
  hasCriteria?: boolean;
  criteriaSuccess?: boolean;
  valueType?: "percentage" | "ratio" | "credit_score" | "money";
  selfReportedValue?: number | null;
  noBorders?: boolean;
  isPermitted: boolean;
  isVerified?: boolean;
  isSelfAttested?: boolean;
  onEditEmp?: () => void;
  empValue?: number | null;
}) => {
  const normalizedValue = useMemo(() => {
    if (value === undefined || value === null) return "-";

    if (["ratio", "percentage"].includes(valueType))
      return `${value.toFixed(2)}${valueType === "ratio" ? "x" : "%"}`;

    if (valueType === "credit_score") return value.toFixed(0);

    return toMoney(value);
  }, [valueType, value]);

  return (
    <div
      className={cx(
        "w-full h-[136px] px-5 flex flex-col justify-center gap-2 py-5",
        noBorders ? "" : "border-b border-l border-alpha-40"
      )}
    >
      <h3 className="text-sm font-medium text-content-1000">{label}</h3>
      <PermittedContent isPermitted={isPermitted} protectedIconSize={32}>
        <div className="flex flex-col gap-1">
          <p className="text-xl flex items-center gap-2 font-bold text-content-1000">
            {criteriaImportance == null ? null : (
              <CriteriaBadgeIcon
                hasCriteria={Boolean(hasCriteria)}
                success={Boolean(criteriaSuccess)}
              />
            )}

            {normalizedValue}
            <Show if={isVerified}>
              <VerifiedBadge />
            </Show>
          </p>
          <Show if={isSelfAttested}>
            <p className="text-content-300 text-sm font-medium">
              Self-reported
            </p>
          </Show>
          <Show if={onEditEmp != null}>
            <div className="flex items-center gap-4">
              <span className="text-sm font-medium text-content-400">
                EMP{" "}
                <span className="font-bold text-content-1000">
                  {toMoney(empValue ?? 0)}
                </span>
              </span>
              <Button
                size={ButtonSize.SM}
                variant={ButtonVariant.TEXT}
                onClick={onEditEmp}
              >
                Edit
              </Button>
            </div>
          </Show>
        </div>
      </PermittedContent>
    </div>
  );
};
